<script>
  import makeChart from '../baseChartWidget'
  import chart from './chart'

  export default makeChart('paymentSupplierType-wdg-cmp', chart)
</script>



// WEBPACK FOOTER //
// src/components/_modules/Dashboard/widgets/PaymentsBySupplierType/index.vue